import { createTheme } from '@mui/material/styles';

// "Game night table": the board sits on dark felt, brass marks whatever needs
// the player's attention (their turn, the card they picked), and the chips keep
// the classic Sequence team colours.
export const tokens = {
    felt: '#123D30',
    feltDeep: '#0B2A21',
    mat: '#0A241C',
    rail: 'rgba(243, 238, 226, 0.08)',
    brass: '#E2B65B',
    brassDeep: '#B98A2E',
    parchment: '#F3EEE2',
    parchmentMuted: 'rgba(243, 238, 226, 0.66)',
    ink: '#16201C',
    paper: '#FBF8F1',
    chips: {
        blue: '#2F6FDB',
        green: '#22A36E',
        red: '#D8433A',
    },
    display: '"Bricolage Grotesque", "Figtree", system-ui, sans-serif',
    body: '"Figtree", system-ui, -apple-system, "Segoe UI", sans-serif',
};

// Teams arrive from the server as "Blue", "green", etc.
export const chipColor = (team) => tokens.chips[String(team || '').toLowerCase()] || String(team || '');

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: { main: tokens.felt, dark: tokens.feltDeep, contrastText: tokens.parchment },
        secondary: { main: tokens.brass, dark: tokens.brassDeep, contrastText: tokens.ink },
        success: { main: tokens.chips.green },
        error: { main: tokens.chips.red },
        background: { default: tokens.paper, paper: '#FFFFFF' },
        text: { primary: tokens.ink, secondary: 'rgba(22, 32, 28, 0.68)' },
    },
    shape: { borderRadius: 10 },
    typography: {
        fontFamily: tokens.body,
        h1: { fontFamily: tokens.display, fontWeight: 700, letterSpacing: '-0.02em' },
        h2: { fontFamily: tokens.display, fontWeight: 700, letterSpacing: '-0.02em' },
        h3: { fontFamily: tokens.display, fontWeight: 700, letterSpacing: '-0.015em' },
        h4: { fontFamily: tokens.display, fontWeight: 650, letterSpacing: '-0.01em' },
        h5: { fontFamily: tokens.display, fontWeight: 650 },
        h6: { fontFamily: tokens.display, fontWeight: 600 },
        button: { textTransform: 'none', fontWeight: 600, letterSpacing: 0 },
    },
    components: {
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: {
                root: { borderRadius: 999, paddingInline: 18 },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 18,
                    backgroundColor: tokens.paper,
                    boxShadow: '0 24px 60px rgba(4, 20, 15, 0.45)',
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: { fontFamily: tokens.display, fontWeight: 700, fontSize: '1.4rem', paddingTop: 22 },
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: { backgroundColor: 'rgba(6, 22, 17, 0.62)', backdropFilter: 'blur(3px)' },
                invisible: { backgroundColor: 'transparent', backdropFilter: 'none' },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: { textTransform: 'none', fontWeight: 600, fontSize: '0.95rem' },
            },
        },
        MuiTabs: {
            styleOverrides: {
                indicator: { backgroundColor: tokens.brassDeep, height: 3, borderRadius: 3 },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: { backgroundColor: '#FFFFFF' },
            },
        },
        MuiPaper: {
            styleOverrides: {
                rounded: { borderRadius: 14 },
            },
        },
    },
});

export default theme;
